import usePermissionCheck from "presentation/hooks/use-check-permissions";
import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import { translateText } from "infra/translation/translate";
import VacationsPanel from "presentation/components/Vacations/VacationsPanel";

const VacationPage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "dashboards" });

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title={translateText("Vacations", "pt")} />
      <VacationsPanel />
    </div>
  );
};

export default VacationPage;
